import * as type from '../actions/types';
import { safeParse } from '../utils/helpers';

const initialState = {
  data: {},
  fetching: false,
  error: false,
  errorMessage: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_BOOKING_RECEIPTS_PENDING: {
      return {
        ...state,
        data: {},
        fetching: true,
        error: false,
        errorMessage: '',
      };
    }
    case type.FETCH_BOOKING_RECEIPTS_SUCCESS: {
      const { data } = action.payload;
      const dataParsed = safeParse(data, {});

      return {
        ...state,
        data: dataParsed,
        fetching: false,
        error: false,
        errorMessage: '',
      };
    }
    case type.FETCH_BOOKING_RECEIPTS_FAILURE: {
      return {
        ...state,
        fetching: false,
        error: true,
        errorMessage: action.payload,
      };
    }
    case type.CLEAR_BOOKING_RECEIPTS: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};
